<template>
  <div ref="text-field-suggest-widget" class="text-field-suggest-widget">
    <input
      ref="keyword-input"
      type="text"
      autocomplete="none"
      v-model="keyword"
      :placeholder="placeholder"
      @input="onInput"
      onfocus="this.select();"
      :style="{paddingRight: paddingRightInput}"
    >
    <div class="invalid" v-if="isInvalid" :style="{right: keyword !== '' ? '32px' : '0px'}">
      <img :src="util.getImagePath('require_verification@2x.png')" :srcset="util.getImageSet('require_verification')">
      <div class="guide" v-if="guide !== ''">{{ guide }}</div>
    </div>
    <button class="clear" v-if="keyword !== ''" @click.stop="clear">
      <img :src="util.getImagePath('x_blue@2x.png')" :srcset="util.getImageSet('x_blue')">
    </button>
    <div class="suggest-container" v-if="isShowSuggest && filteredSuggests.length > 0">
      <div ref="suggest-list" class="suggest-list">
        <div class="suggest-row"
          v-for="(suggest, i) in filteredSuggests"
          :key="i" @click="select(suggest)"
        >
          <div class="name">
            {{ suggest }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextFieldSuggestWidget',
  props: {
    value: null,
    suggests: {
      type: Array,
      default: [],
      required: true
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    guide: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      keyword: '',
      isShowSuggest: false
    }
  },
  mounted () {
    var self = this
    self.$root.$on('clickOnWindow', self.clickOnWindow)
    window.addEventListener('click', self.clickOnWindow)
    window.addEventListener('touchstart', self.clickOnWindow)
    self.keyword = self.value
  },
  computed: {
    filteredSuggests () {
      var self = this
      return (self.suggests || []).filter(suggest => {
        var isMatch = suggest.toLowerCase().indexOf(self.keyword.toLowerCase()) !== -1
        var isEmptyKeyword = self.keyword === ''
        return isMatch || isEmptyKeyword
      })
    },
    paddingRightInput () {
      var self = this
      if (self.keyword !== '' && self.isInvalid) {
        return '59px'
      } else if (self.keyword !== '' && !self.isInvalid) {
        return '27px'
      } else if (self.keyword === '' && self.isInvalid) {
        return '27px'
      }
      return '0px'
    }
  },
  methods: {
    clickOnWindow (e) {
      var self = this
      self.isShowSuggest = (self.$refs['text-field-suggest-widget'] === e.target || self.$refs['text-field-suggest-widget'].contains(e.target))
    },
    select (value) {
      var self = this
      // self.keyword = value
      self.$emit('select', value)
      self.$nextTick(() => {
        self.isShowSuggest = false
      })
    },
    onInput () {
      var self = this
      self.isShowSuggest = true
    },
    clear () {
      var self = this
      self.keyword = ''
      self.$nextTick(() => {
        self.$refs['keyword-input'].focus()
      })
    }
  },
  watch: {
    keyword () {
      var self = this
      self.$nextTick(() => {
        self.$emit('input', self.keyword)
      })
    },
    value (newValue) {
      var self = this
      self.$nextTick(() => {
        self.keyword = newValue
      })
    }
  },
  beforeDestroy () {
    var self = this
    self.$root.$off('clickOnWindow')
    window.removeEventListener('click', self.clickOnWindow)
    window.removeEventListener('touchstart', self.clickOnWindow)
  }
}
</script>

<style scoped>
  .text-field-suggest-widget {
    position: relative;
  }

  .text-field-suggest-widget > input[type="text"] {
    border: none;
    width: 100%;
    height: 36px;
    padding: 0px 0px 0px 0px;
    font-size: 16px;
    box-sizing: border-box;
    background-color: transparent;
    font-family: Default-PromptPai-Medium;
    line-height: 36px;
    text-indent: 2px;
  }

  .text-field-suggest-widget > input[type="text"]::placeholder {
    color: rgb(175, 175, 175);
    font-size: 15px;
    text-indent: 2px;
  }

  .invalid {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .invalid img {
    width: 24px;
    height: 24px;
  }

  .invalid .guide {
    position: absolute;
    bottom: -4px;
    right: -4px;
    transform: translate(0%, 100%);
    color: rgb(255, 255, 255);
    z-index: 1;
    background-color: rgb(209 11 15);
    padding: 3px 8px;
    border-radius: 4px !important;
    font-size: 12px;
    font-family: Prompt;
    box-shadow: 0px 0px 1px 2px rgba(0, 0, 0, 0.2);
    width: max-content;
    z-index: 12;
  }

  .invalid .guide:after {
    z-index: -99;
    content: "";
    position: absolute;
    width: 0px;
    height: 0px;
    bottom: 0;
    top: 1px;
    right: 0px;
    box-sizing: border-box;
    border: 6px solid rgb(209 11 15);
    border-color: transparent transparent rgb(209 11 15) rgb(209 11 15);
    transform-origin: 0 0;
    transform: rotate(135deg);
  }

  button.clear {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 36px;
    height: 36px;
    padding: 0px;
    border: none;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
  }

  button.clear img {
    width: 24px;
    height: 24px;
  }

  .suggest-container {
    position: absolute;
    background-color: rgb(255, 255, 255);
    width: 100%;
    left: 0px;
    padding: 10px;
    box-sizing: border-box;
    z-index: 20;
    box-shadow: 0px 4px 4px 4px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }

  .suggest-list {
    overflow-y: auto;
    max-height: 200px;
  }

  .suggest-list::-webkit-scrollbar {
    background-color: rgb(251, 251, 251);
  }
  .suggest-list::-webkit-scrollbar-thumb {
    border: 2px solid rgb(251, 251, 251);
  }

  .suggest-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    min-height: 36px;
    margin: 0px;
    cursor: pointer;
    padding: 8px 0px;
    box-sizing: border-box;
  }

  .suggest-row:hover {
    background-color: rgb(227, 227, 227);
  }

  .suggest-row > .icon-category-container {
    height: 36px;
    width: 36px;
    padding: 8px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .suggest-row > .icon-category-container > img {
    max-height: 16px;
    max-width: 16px;
  }

  .suggest-row > .name {
    width: 100%;
    padding: 2px 0px 0px 10px;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/TextFieldSuggestWidget.vue